// extracted by mini-css-extract-plugin
export default {"content":"Accounting_content__AL1qm","content__accounting":"Accounting_content__accounting__aZufO"};